import { render, staticRenderFns } from "./LiefengContentArea.vue?vue&type=template&id=8141295c&scoped=true&"
import script from "./LiefengContentArea.vue?vue&type=script&lang=js&"
export * from "./LiefengContentArea.vue?vue&type=script&lang=js&"
import style0 from "./LiefengContentArea.vue?vue&type=style&index=0&id=8141295c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8141295c",
  null
  
)

export default component.exports